export default "__VITE_ASSET__B33BzmTE__"